import { useOutletContext } from "react-router-dom";
import type { StoreRouteContext } from "features/store/types";
import Audits from "./Audits";

export default function StoreAuditsPage() {
  const routeContext = useOutletContext<StoreRouteContext | undefined>();

  return <Audits selectedStore={routeContext?.storeDetails} />;
}
